import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=5125f504&"
import script from "./FacebookButton.vue?vue&type=script&lang=js&"
export * from "./FacebookButton.vue?vue&type=script&lang=js&"
import style0 from "./FacebookButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports